import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/progressive-web/pwa-discuss.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundPosition: "center top",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={8} lg={7} xl={6} xxl={6}>
            <h2>Want to discuss your unique PWA ideas with Us?</h2>
            <p>
              We’re ready to understand your needs and provide you with expert
              insights tailored just for you. Let's create something exceptional
              together.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book a Consultation Today
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
